const DEFAULT_API_PORT = '5000';

/**
 * Адрес API берём с того же компьютера, с которого открыли сайт.
 * С вашего ПК это localhost, с ноутбуков в Wi‑Fi — IP вашего компа.
 * Жёсткий REACT_APP_API_URL в .env как раз ломал одну из сторон.
 */
const resolveApiUrl = (): string => {
  const override = process.env.REACT_APP_API_URL?.trim();
  if (override) return override.replace(/\/$/, '');

  const port = process.env.REACT_APP_API_PORT?.trim() || DEFAULT_API_PORT;
  if (typeof window === 'undefined') {
    return `http://localhost:${port}`;
  }

  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  return `${protocol}//${window.location.hostname}:${port}`;
};

const ApiUrl = resolveApiUrl();

export default ApiUrl;
export const { REACT_APP_HEADER } = process.env;
